module.exports = __webpack_public_path__ + "static/media/bannerInicio.6c56e234.png";